import { Routes } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { AuthGuard } from 'app/auth.guard';

export const ROUTES: Routes = [
  {
   path: '', redirectTo: 'app', pathMatch: 'full'
  },
  {
    path: 'app',
    loadChildren: './visualis/visualis.module#VisualisLayoutModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'login', loadChildren: './login/login.module#LoginModule'
  },
  {
    path: 'visframe/:mode/:clientid/:dashid/:lang/:appkey',
    loadChildren: './visualis/visframe/visframe.module#VisFramehModule'
  },
  {
    path: 'error', component: ErrorComponent
  },
  {
    path: '**', component: ErrorComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts